import Vue from 'vue'
import App from './App.vue'
//import store from './store'
import './quasar'
import VueGtm from 'vue-gtm'
import Analytics from "./analytics"
import Counter from './counter'
import CopyClipboard from './copy-to-clipboard'

Vue.config.productionTip = false

Vue.use(VueGtm, {
  id: 'GTM-KKDBD9'
})

Vue.use(Analytics, {
  category: "chouette"
})

Vue.use(Counter)
Vue.use(CopyClipboard)

new Vue({
  //store,
  render: h => h(App)
}).$mount('#app')

